import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { ValidatedAmount } from "@/integrations/supabase/database.types";

interface PaymentMethodDetailsProps {
  validatedAmounts: ValidatedAmount[];
}

export const PaymentMethodDetails = ({ validatedAmounts }: PaymentMethodDetailsProps) => {
  if (!validatedAmounts || validatedAmounts.length === 0) return null;

  return (
    <div className="space-y-4">
      <h4 className="font-medium">Détails par méthode de paiement</h4>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {validatedAmounts.map((item) => (
          <Card key={item.id}>
            <CardHeader>
              <CardTitle className="text-sm font-medium">
                {item.payment_method}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-lg font-semibold text-orange-500">
                {item.amount.toLocaleString()} FCFA
              </div>
              <div className="text-sm text-gray-500">
                {format(new Date(item.counting_date), 'PPP', { locale: fr })}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};